import React, { Fragment, useState } from 'react';


const ExpenseInfo = ({ expense }) => {

    const [this_expense, setThis_expense] = useState(expense)
    return (
        <Fragment>
            <button type="button" className="btn btn-info" data-toggle="modal" data-target={`#id_admin${this_expense.expense_id}`}>
                Expand
            </button>

            <div className="modal fade" id={`id_admin${this_expense.expense_id}`}>
                <div className="modal-dialog">
                    <div className="modal-content">

                        <div className="modal-header">
                            <h4 className="modal-title">Shift Information</h4>
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                        </div>

                        <div className="modal-body">
                            <p>Expense ID: {this_expense.expense_id}</p>

                            <p>Cost: ${this_expense.cost_cents / 100}</p>
                            <p>Description: {this_expense.expense_description}</p>
                            <p>Proof? {this_expense.submitted_proof_display}</p>
                            
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-success" data-dismiss="modal">Close</button>
                        </div>

                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default ExpenseInfo;